document.addEventListener('click', e => {
  const btn = e.target.closest('.menu-toggle');
  if (btn) {
    const nav = document.getElementById('MobileNav');
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    if (expanded) { nav.setAttribute('hidden', ''); } else { nav.removeAttribute('hidden'); }
  }
  const accHead = e.target.closest('.accordion .head');
  if (accHead) {
    const body = accHead.parentElement.querySelector('.body');
    const open = body.style.display === 'block';
    body.style.display = open ? 'none' : 'block';
  }
  const closePopup = e.target.closest('[data-close-popup]');
  if (closePopup) document.querySelectorAll('.popup').forEach(p => p.style.display='none');
  const cookieBtn = e.target.closest('[data-accept-cookies]');
  if (cookieBtn) {
    localStorage.setItem('cookiesAccepted','1');
    const cb = document.querySelector('.cookie'); if (cb) cb.style.display='none';
  }
});
const slider = document.querySelector('[data-slider]');
if (slider) {
  let index = 0;
  setInterval(() => {
    const quotes = slider.querySelectorAll('.quote');
    quotes.forEach((q, i) => q.style.display = i === index % quotes.length ? 'block' : 'none');
    index++;
  }, 4000);
}
window.addEventListener('load', () => {
  const popup = document.querySelector('.popup');
  if (popup && popup.dataset.delay) setTimeout(() => { popup.style.display='grid'; }, parseInt(popup.dataset.delay,10)||3000);
  const cookie = document.querySelector('.cookie');
  if (cookie && !localStorage.getItem('cookiesAccepted')) cookie.style.display='block';
});
